// @flow
import { envTypes } from '@atlassiansox/metal-client';
import type { EnvironmentConfig } from 'model/EnvironmentConfig';

export default (): EnvironmentConfig => ({
  atlAdminUrl: 'https://admin.stg.atlassian.com',
  clicktaleEnabled: true,
  hamletUrl: 'https://hamlet.stg.internal.atlassian.com',
  directHamletUrl: 'https://hamlet.stg.internal.atlassian.com',
  hamsUrl: 'https://hams.stg.internal.atlassian.com',
  idLoginUrl: 'https://id.stg.internal.atlassian.com/login',
  launchdarklyId: '5760d13530f55306ec000133',
  logoutUrl: () =>
    `https://id.stg.internal.atlassian.com/logout?continue=${encodeURIComponent(
      document.location.href,
    )}`,
  macUrl: 'https://my.stg.internal.atlassian.com',
  marketplaceUrl: 'https://marketplace.stg.internal.atlassian.com',
  padresUrl: 'https://marketplace.stg.internal.atlassian.com/padres',
  paypal: {
    env: 'sandbox',
  },
  segmentKey: 'EWfeqJKJ0rPNOe3fcXrh2dg7bVXZNi2I',
  sentry: {
    debug: true,
    environment: 'stg',
  },
  tnsSessionUrl:
    'https://secure.na.tnspayments.com/form/version/34/merchant/TESTATLASSIAN02/session.js',
  wacUrl: 'https://wac.stg.internal.atlassian.com',
  i18nUrl: 'https://cart-static.us-east-1.staging.public.atl-paas.net/i18n',
  metal: {
    environment: envTypes.STAGING,
  },
  cloudMigrationToolsUrl: 'https://api-private.stg.atlassian.com/cloud-migration-tools',
  root: 'https://wac.stg.internal.atlassian.com/purchase',
  partnerPortal: 'https://partners.stg.internal.atlassian.com',
  intercomAppID: 'odnoznr4',
  adminHubUrl: 'https://admin.stg.atlassian.com',
});
